/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ikte",
        "-2": "oovdebpeivvi",
        "0": "odne",
        "1": "ihttin",
        "2": "paijeelittáá",
        "future": {
          "one": "{0} jándor maŋŋilit",
          "other": "{0} jándora maŋŋilit",
          "two": "{0} jándor amaŋŋilit"
        },
        "past": {
          "one": "{0} jándor árat",
          "other": "{0} jándora árat",
          "two": "{0} jándora árat"
        }
      },
      "day-narrow": {
        "-1": "ikte",
        "-2": "oovdebpeivvi",
        "0": "odne",
        "1": "ihttin",
        "2": "paijeelittáá",
        "future": {
          "one": "{0} jándor maŋŋilit",
          "other": "{0} jándora maŋŋilit",
          "two": "{0} jándor amaŋŋilit"
        },
        "past": {
          "one": "{0} jándor árat",
          "other": "{0} jándora árat",
          "two": "{0} jándora árat"
        }
      },
      "day-short": {
        "-1": "ikte",
        "-2": "oovdebpeivvi",
        "0": "odne",
        "1": "ihttin",
        "2": "paijeelittáá",
        "future": {
          "one": "{0} jándor maŋŋilit",
          "other": "{0} jándora maŋŋilit",
          "two": "{0} jándor amaŋŋilit"
        },
        "past": {
          "one": "{0} jándor árat",
          "other": "{0} jándora árat",
          "two": "{0} jándora árat"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "one": "{0} diibmu maŋŋilit",
          "other": "{0} diibmur maŋŋilit",
          "two": "{0} diibmur maŋŋilit"
        },
        "past": {
          "one": "{0} diibmu árat",
          "other": "{0} diibmur árat",
          "two": "{0} diibmur árat"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "one": "{0} diibmu maŋŋilit",
          "other": "{0} diibmur maŋŋilit",
          "two": "{0} diibmur maŋŋilit"
        },
        "past": {
          "one": "{0} diibmu árat",
          "other": "{0} diibmur árat",
          "two": "{0} diibmur árat"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "one": "{0} diibmu maŋŋilit",
          "other": "{0} diibmur maŋŋilit",
          "two": "{0} diibmur maŋŋilit"
        },
        "past": {
          "one": "{0} diibmu árat",
          "other": "{0} diibmur árat",
          "two": "{0} diibmur árat"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "one": "{0} minuhta maŋŋilit",
          "other": "{0} minuhtta maŋŋilit",
          "two": "{0} minuhtta maŋŋilit"
        },
        "past": {
          "one": "{0} minuhta árat",
          "other": "{0} minuhtta árat",
          "two": "{0} minuhtta árat"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "one": "{0} minuhta maŋŋilit",
          "other": "{0} minuhtta maŋŋilit",
          "two": "{0} minuhtta maŋŋilit"
        },
        "past": {
          "one": "{0} minuhta árat",
          "other": "{0} minuhtta árat",
          "two": "{0} minuhtta árat"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "one": "{0} minuhta maŋŋilit",
          "other": "{0} minuhtta maŋŋilit",
          "two": "{0} minuhtta maŋŋilit"
        },
        "past": {
          "one": "{0} minuhta árat",
          "other": "{0} minuhtta árat",
          "two": "{0} minuhtta árat"
        }
      },
      "month": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "{0} mánotbadji maŋŋilit",
          "other": "{0} mánotbadji maŋŋilit",
          "two": "{0} mánotbadji maŋŋilit"
        },
        "past": {
          "one": "{0} mánotbadji árat",
          "other": "{0} mánotbadji árat",
          "two": "{0} mánotbadji árat"
        }
      },
      "month-narrow": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "{0} mánotbadji maŋŋilit",
          "other": "{0} mánotbadji maŋŋilit",
          "two": "{0} mánotbadji maŋŋilit"
        },
        "past": {
          "one": "{0} mánotbadji árat",
          "other": "{0} mánotbadji árat",
          "two": "{0} mánotbadji árat"
        }
      },
      "month-short": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "{0} mánotbadji maŋŋilit",
          "other": "{0} mánotbadji maŋŋilit",
          "two": "{0} mánotbadji maŋŋilit"
        },
        "past": {
          "one": "{0} mánotbadji árat",
          "other": "{0} mánotbadji árat",
          "two": "{0} mánotbadji árat"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "one": "{0} sekunda maŋŋilit",
          "other": "{0} sekundda maŋŋilit",
          "two": "{0} sekundda maŋŋilit"
        },
        "past": {
          "one": "{0} sekunda árat",
          "other": "{0} sekundda árat",
          "two": "{0} sekundda árat"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "one": "{0} sekunda maŋŋilit",
          "other": "{0} sekundda maŋŋilit",
          "two": "{0} sekundda maŋŋilit"
        },
        "past": {
          "one": "{0} sekunda árat",
          "other": "{0} sekundda árat",
          "two": "{0} sekundda árat"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "one": "{0} sekunda maŋŋilit",
          "other": "{0} sekundda maŋŋilit",
          "two": "{0} sekundda maŋŋilit"
        },
        "past": {
          "one": "{0} sekunda árat",
          "other": "{0} sekundda árat",
          "two": "{0} sekundda árat"
        }
      },
      "week": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "{0} vahku maŋŋilit",
          "other": "{0} vahkku maŋŋilit",
          "two": "{0} vahkku maŋŋilit"
        },
        "past": {
          "one": "{0} vahku árat",
          "other": "{0} vahkku árat",
          "two": "{0} vahkku árat"
        }
      },
      "week-narrow": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "{0} vahku maŋŋilit",
          "other": "{0} vahkku maŋŋilit",
          "two": "{0} vahkku maŋŋilit"
        },
        "past": {
          "one": "{0} vahku árat",
          "other": "{0} vahkku árat",
          "two": "{0} vahkku árat"
        }
      },
      "week-short": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "{0} vahku maŋŋilit",
          "other": "{0} vahkku maŋŋilit",
          "two": "{0} vahkku maŋŋilit"
        },
        "past": {
          "one": "{0} vahku árat",
          "other": "{0} vahkku árat",
          "two": "{0} vahkku árat"
        }
      },
      "year": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "{0} jahki maŋŋilit",
          "other": "{0} jahkki maŋŋilit",
          "two": "{0} jahkki maŋŋilit"
        },
        "past": {
          "one": "{0} jahki árat",
          "other": "{0} jahkki árat",
          "two": "{0} jahkki árat"
        }
      },
      "year-narrow": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "{0} jahki maŋŋilit",
          "other": "{0} jahkki maŋŋilit",
          "two": "{0} jahkki maŋŋilit"
        },
        "past": {
          "one": "{0} jahki árat",
          "other": "{0} jahkki árat",
          "two": "{0} jahkki árat"
        }
      },
      "year-short": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "{0} jahki maŋŋilit",
          "other": "{0} jahkki maŋŋilit",
          "two": "{0} jahkki maŋŋilit"
        },
        "past": {
          "one": "{0} jahki árat",
          "other": "{0} jahkki árat",
          "two": "{0} jahkki árat"
        }
      }
    },
    "locale": "se"
  });
}